import { useEffect, useState } from "react";

const PILLARS = ["connect", "educate", "inspire", "secure"];

async function api(path) {
  return fetch(path, { credentials: "same-origin" });
}

function Stat({ n, label }) {
  return (
    <div className="stat">
      <div className="n">{n}</div>
      <div className="l">{label}</div>
    </div>
  );
}

export function Dashboard({ chapterId }) {
  const [data, setData] = useState(null);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [copied, setCopied] = useState(false);

  function load(f, t) {
    const qs = f && t ? `?from=${f}&to=${t}` : "";
    api(`/api/chapters/${chapterId}/dashboard${qs}`)
      .then((res) => (res.ok ? res.json() : null))
      .then((d) => {
        if (!d) return;
        setData(d);
        setFrom(d.period.from);
        setTo(d.period.to);
      });
  }
  useEffect(() => load(), [chapterId]);

  if (data === null) return <p className="muted">Loading dashboard…</p>;
  const { totals, quarter, period } = data;
  const maxPillar = Math.max(1, ...PILLARS.map((p) => quarter.by_pillar[p] || 0));

  function copySummary() {
    const lines = [
      `ISC2 chapter report — ${period.from} to ${period.to}`,
      `Members: ${totals.members} (+${quarter.new_members} new this period) · Prospects: ${totals.prospects}`,
      `Events this period: ${quarter.events} · Attendance: ${quarter.attendance}`,
      `Value pillars — Connect: ${quarter.by_pillar.connect}, Educate: ${quarter.by_pillar.educate}, Inspire: ${quarter.by_pillar.inspire}, Secure: ${quarter.by_pillar.secure}`,
      `Upcoming events: ${totals.events_upcoming} · Meetings held: ${totals.meetings} · Open actions: ${totals.open_actions}`,
    ];
    navigator.clipboard.writeText(lines.join("\n"));
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <div className="section">
      <div className="section-head">
        <h3>Chapter at a glance</h3>
      </div>
      <div className="stat-grid">
        <Stat n={totals.members} label="Members" />
        <Stat n={totals.prospects} label="Prospects" />
        <Stat n={totals.events_upcoming} label="Upcoming events" />
        <Stat n={totals.events_past} label="Past events" />
        <Stat n={totals.meetings} label="Meetings" />
        <Stat n={totals.open_actions} label="Open actions" />
      </div>

      <div className="form-card" style={{ marginTop: 16 }}>
        <div className="section-head" style={{ marginBottom: 10 }}>
          <h3 style={{ margin: 0 }}>Report period</h3>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            {copied && <span className="saved">Copied</span>}
            <button className="btn-ghost" type="button" onClick={copySummary}>Copy for ISC2 report</button>
          </div>
        </div>
        <div style={{ display: "flex", gap: 10, alignItems: "end", flexWrap: "wrap", marginBottom: 14 }}>
          <label className="field">From<input type="date" value={from} onChange={(e) => setFrom(e.target.value)} /></label>
          <label className="field">To<input type="date" value={to} onChange={(e) => setTo(e.target.value)} /></label>
          <button className="btn-ghost" type="button" onClick={() => load(from, to)}>Apply</button>
        </div>
        <div className="stat-grid">
          <Stat n={quarter.new_members} label="New members" />
          <Stat n={quarter.events} label="Events" />
          <Stat n={quarter.attendance} label="RSVP attendance" />
        </div>
        <div style={{ marginTop: 16 }}>
          <div className="l" style={{ color: "var(--muted)", fontSize: 13, marginBottom: 8 }}>Events by value pillar</div>
          {PILLARS.map((p) => (
            <div key={p} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
              <span style={{ width: 70, textTransform: "capitalize", fontSize: 13 }}>{p}</span>
              <div className="bar" style={{ flex: 1 }}>
                <span style={{ width: `${((quarter.by_pillar[p] || 0) / maxPillar) * 100}%` }} />
              </div>
              <span style={{ width: 20, textAlign: "right", fontSize: 13 }}>{quarter.by_pillar[p] || 0}</span>
            </div>
          ))}
          {quarter.by_pillar.untagged > 0 && (
            <div className="muted" style={{ fontSize: 12, marginTop: 6 }}>{quarter.by_pillar.untagged} event(s) not yet tagged to a pillar.</div>
          )}
        </div>
      </div>
    </div>
  );
}
